'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Constants = require('../actions/Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Handles changing the app's form configuration received from the API.
 * @param {Object} state - The current form configuration object.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} The new form configuration object.
 */
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loaded: false, config: null };
  var action = arguments[1];

  switch (action.type) {
    case Constants.GET_FORM_CONFIG_COMPLETE:
      if (!action.error) {
        return {
          loaded: true,
          config: action.payload.data
        };
      }

      return state;
    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/reducers/formConfig.js
// module id = 1730
// module chunks = 0